/*
  Export an object that can be required across multiple
  files and can be written to without breaking the reference
*/
const context = {
  /*
    usersCanSeeSchedulesInOtherLocations,
    usersCanSeeSchedulesForOtherPositions,
    canSeeUser(),
    usTimeFormat,
    showLastNameFirst,
    me,
    orgUsers,
    orgLocations,
    orgPositions,
    personasDict,
    isTimeOff(),
    getTimeOffTypes(),
  */
  // safety check defaults
  isOrgFeatureEnabled: () => false,
  getDecimalFormat: () => null,
  gettext: (t) => t,
};

export default context;
